import React, { useEffect, useRef } from 'react';
import { LocationStoreView } from '../../types/locations';
import { LocationStore } from '../../location-store';
import { LocationSelectFormattedLocationDisplay } from '../common/location-select-formatted-location-display';
import { Box } from '@cad-arc';
import { observer } from 'mobx-react';
import { CommonSize } from '../../../common/helpers/utils';

interface AddressRowProps {
    row: LocationStoreView;
    query: string;
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    index: number;
    store: LocationStore;
    mode?: 'LIST' | 'MAP';
    size?: CommonSize;
}

export const LocationListRow = observer(
    ({ row, onClick, query, store, index, mode, size }: AddressRowProps) => {
        const ref = useRef<HTMLDivElement | null>(null);
        const isSelected = index === store.highlightedLocationIndex;

        useEffect(() => {
            if (
                ref.current &&
                store.highlightedLocationIndex === index &&
                store.shouldScrollLocationList
            ) {
                ref.current.scrollIntoView(false);
            }
        }, [store.highlightedLocationIndex, index, store.shouldScrollLocationList]);

        return (
            <Box
                onMouseEnter={() => {
                    store.setHighlightedLocationIndex(index, { source: 'mouse' });
                }}
                style={{
                    backgroundColor: isSelected ? 'var(--arc-colors-interactive-hover)' : undefined,
                }}
                data-testid={`address-row-${row.id}`}
                key={row.id}
                onMouseDown={(e) => onClick(e)}
                ref={ref}
                p={3}
            >
                <LocationSelectFormattedLocationDisplay
                    location={row}
                    query={query}
                    size={size}
                    showMapKeyMarker={mode === 'MAP'}
                    index={index}
                    isSelected={isSelected}
                />
            </Box>
        );
    }
);
